"use client"

import { useEffect } from "react"
import { clientCookies } from "@/lib/clientCookies"
import { emitGTMEvent } from "./utilities"

interface DatalayerErrorProps {
  errorType: string
  errorMessage: string
}

export const DatalayerError = ({
  errorType,
  errorMessage,
}: DatalayerErrorProps) => {
  useEffect(() => {
    emitGTMEvent({
      event: "error",
      error_type: errorType,
      error_message: errorMessage,
      previous_page: clientCookies.get("prev_page") || null,
      current_page: window.location.pathname,
    })
  }, [errorType, errorMessage])

  return null
}

export default DatalayerError
